import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../services/baseQuery";

export const employeeApi = createApi({
  reducerPath: "employeeApi",
  baseQuery:appBaseQuery,
  endpoints: (builder) => ({
    getEmployeeByCode: builder.query({
      query: (employeeCode) => `employee/${employeeCode}`,
    }),
  }),
});

export const { useLazyGetEmployeeByCodeQuery } = employeeApi;
